module.exports = __webpack_public_path__ + "static/media/cq_andamento_finanziamenti.7711538f.svg";